import axios from 'axios';

/**
 * Busca informações de endereço por CEP na BrasilAPI (v2 com fallback para v1).
 * @param {string} cep CEP com ou sem formatação
 * @returns {Promise<{ cep: string, state: string, city: string, neighborhood: string, street: string }>}
 */
export async function fetchCepInfo(cep) {
  const cleanCep = (cep || '').replace(/\D/g, '');
  if (cleanCep.length !== 8) {
    throw new Error('CEP deve conter 8 dígitos.');
  }

  try {
    const response = await axios.get(`https://brasilapi.com.br/api/cep/v2/${cleanCep}`);
    return response.data;
  } catch (errV2) {
    // Fallback para CEP v1
    const response = await axios.get(`https://brasilapi.com.br/api/cep/v1/${cleanCep}`);
    return response.data;
  }
}

/**
 * Busca informações cadastrais de pessoa jurídica por CNPJ na BrasilAPI.
 * @param {string} cnpj CNPJ com ou sem formatação
 * @returns {Promise<any>}
 */
export async function fetchCnpjInfo(cnpj) {
  const cleanCnpj = (cnpj || '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
  if (cleanCnpj.length !== 14) {
    throw new Error('CNPJ deve conter 14 caracteres alfanuméricos.');
  }

  const response = await axios.get(`https://brasilapi.com.br/api/cnpj/v1/${cleanCnpj}`);
  return response.data;
}
